import { z } from 'zod'

export const Int32DtoSchema = z.number().int().nonnegative()

export type Int32Dto = z.infer<typeof Int32DtoSchema>
